var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function addMultipleListeners(element, events, handler, useCapture = false, args = []) {
    if (!element) {
        return;
    }
    if (!Array.isArray(events)) {
        throw new TypeError('addMultipleListeners: please supply an array of event strings (like ["click", "mouseover"])');
    }
    const handlerFn = (e) => handler(e, Array.isArray(args) ? args : []);
    events.forEach(event => {
        element.addEventListener(event, handlerFn, useCapture);
    });
}
// ------------------------------------------------------ //
// Create url
// ------------------------------------------------------ //
export function slugify(string) {
    const map = {
        'à': 'a', 'á': 'a', 'â': 'a', 'ä': 'a', 'æ': 'a', 'ã': 'a', 'å': 'a', 'ā': 'a', 'ă': 'a', 'ą': 'a',
        'ç': 'c', 'ć': 'c', 'č': 'c', 'đ': 'd', 'ď': 'd',
        'è': 'e', 'é': 'e', 'ê': 'e', 'ë': 'e', 'ē': 'e', 'ė': 'e', 'ę': 'e', 'ě': 'e',
        'ğ': 'g', 'ǵ': 'g',
        'ḧ': 'h',
        'î': 'i', 'ï': 'i', 'í': 'i', 'ī': 'i', 'į': 'i', 'ì': 'i',
        'ł': 'l',
        'ḿ': 'm',
        'ñ': 'n', 'ń': 'n', 'ǹ': 'n', 'ň': 'n',
        'ô': 'o', 'ö': 'o', 'ò': 'o', 'ó': 'o', 'œ': 'o', 'ø': 'o', 'ō': 'o', 'õ': 'o', 'ő': 'o',
        'ṕ': 'p',
        'ŕ': 'r', 'ř': 'r',
        'ß': 's', 'ś': 's', 'š': 's', 'ş': 's', 'ș': 's',
        'ť': 't', 'ț': 't',
        'û': 'u', 'ü': 'u', 'ù': 'u', 'ú': 'u', 'ū': 'u', 'ǘ': 'u', 'ů': 'u', 'ű': 'u', 'ų': 'u',
        'ẃ': 'w',
        'ẍ': 'x',
        'ÿ': 'y', 'ý': 'y',
        'ž': 'z', 'ź': 'z', 'ż': 'z',
        '·': '-', '/': '-', '_': '-', ',': '-', ':': '-', ';': '-'
    };
    return string.toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;]/g, match => map[match] || '') // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
}
export function loadScript(url, callback) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.async = true;
            script.defer = true;
            script.src = url;
            script.onload = () => {
                callback();
                resolve();
            };
            script.onerror = () => {
                console.error(`Failed to load script: ${url}`);
                reject(new Error(`Failed to load script: ${url}`));
            };
            document.body.appendChild(script);
        });
    });
}
export function loadCSS(href_1, before_1) {
    return __awaiter(this, arguments, void 0, function* (href, before, media = 'all') {
        var _a;
        const ss = document.createElement("link");
        const ref = before || document.getElementsByTagName("script")[0];
        ss.rel = "stylesheet";
        ss.href = href;
        ss.media = "only x";
        (_a = ref.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(ss, ref);
        ss.onload = () => {
            ss.media = media;
        };
        ss.onerror = () => {
            console.error(`Failed to load CSS: ${href}`);
        };
        return ss;
    });
}
// ------------------------------------------------------ //
// Ajax class (GET | POST)
// ------------------------------------------------------ //
export class Ajax {
    constructor(method, headers = {}) {
        this.method = method;
        this.headers = headers;
    }
    request(url, callback, errorCallback, form) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.method === 'GET') {
                    yield this.ajaxGet(url, callback, errorCallback);
                }
                else if (this.method === 'POST') {
                    if (form) {
                        const formUrl = form.action;
                        yield this.ajaxPost(formUrl, form, callback, errorCallback);
                    }
                    else {
                        throw new Error('No form provided for POST request.');
                    }
                }
            }
            catch (error) {
                if (errorCallback) {
                    errorCallback(error);
                }
                else {
                    console.error('Request error:', error);
                }
            }
        });
    }
    ajaxGet(url, callback, errorCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield fetch(url, { headers: this.headers });
                if (response.ok) {
                    const contentType = response.headers.get('Content-Type');
                    let responseData;
                    if (contentType && contentType.includes('application/json')) {
                        responseData = yield response.json();
                    }
                    else {
                        responseData = yield response.text();
                    }
                    callback(responseData);
                }
                else {
                    throw new Error(`Server returned an error: ${response.status} ${response.statusText}`);
                }
            }
            catch (error) {
                if (errorCallback) {
                    errorCallback(error);
                }
                else {
                    console.error('There was a connection error:', error);
                }
            }
        });
    }
    ajaxPost(url, form, callback, errorCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = this.serialize(form); // Corrected variable name
            if (!form.action) {
                throw new Error('Form is missing an action URL.');
            }
            url = form.action;
            // Extract and append query parameters from action URL
            const urlParts = url.split('?');
            if (urlParts.length > 1) {
                url = urlParts[0];
                const queryParams = new URLSearchParams(urlParts[1]);
                queryParams.forEach((value, key) => {
                    data += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                });
            }
            try {
                const response = yield fetch(url, {
                    method: 'POST',
                    headers: Object.assign({ 'Content-Type': 'application/x-www-form-urlencoded' }, this.headers),
                    body: data,
                });
                if (response.ok) {
                    const contentType = response.headers.get('Content-Type');
                    let responseData;
                    if (contentType && contentType.includes('application/json')) {
                        responseData = yield response.json();
                    }
                    else {
                        responseData = yield response.text();
                    }
                    if (!responseData) {
                        console.warn('Response data is empty');
                    }
                    callback(responseData);
                }
                else {
                    throw new Error(`Server returned an error: ${response.status} ${response.statusText}`);
                }
            }
            catch (error) {
                if (errorCallback) {
                    errorCallback(error);
                }
                else {
                    console.error('Connection error:', error);
                }
            }
        });
    }
    serialize(form) {
        const serialized = [];
        for (const field of Array.from(form.elements)) {
            if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button')
                continue;
            if (field instanceof HTMLSelectElement && field.type === 'select-multiple') {
                for (const option of Array.from(field.options)) {
                    if (option.selected) {
                        serialized.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(option.value)}`);
                    }
                }
            }
            else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                serialized.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`);
            }
        }
        return serialized.join('&');
    }
}
